module.exports = __webpack_public_path__ + "static/media/unsure.6e7b16b7.jpg";